import React from "react";

import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';

const LoginHome = () => {
    return (
        <div>
            <Container maxWidth="lg">
                Welcome to the Login Home Page
            </Container>
        </div>
    )
}
export default LoginHome;